export default "__VITE_ASSET__Ck7wgz1u__"